import { sanitizeFieldName } from './fieldNameSanitizer';
import { CUSTOM_FIELD_NAME_PREFIX } from './getModelPath';
import { safeJSON } from '@utmost.co/utmost-design-system';

// Convert customFields from an array to an object.
export function customFieldsPrefixer(object: any = {}): any {
  try {
    return safeJSON.fromString(
      JSON.stringify(object, (key, value) => {
        if (key === 'customFields' && !!value) {
          try {
            const customFields: any = {};

            if (Array.isArray(value)) {
              value = value
                .filter((customF) => !!customF.definition)
                .reduce((acc, current) => {
                  acc[current.definition.code] = current;
                  return acc;
                }, {});
            }

            Object.entries(value).forEach(([key, value]) => {
              const standardisedKey = sanitizeFieldName(key);
              if (!key.startsWith(CUSTOM_FIELD_NAME_PREFIX)) {
                customFields[CUSTOM_FIELD_NAME_PREFIX + standardisedKey] = value;
              } else {
                customFields[standardisedKey] = value;
              }
            });
            return customFields;
          } catch (e) {
            return value;
          }
        }
        return value;
      })
    );
  } catch (e) {
    return object;
  }
}
